export class StatusMessage {

    public static Status_OK = '200';
    public static Status_Created = '201';
    public static Status_InternalServerError = '500';
    public static Status_BadRequest = '400';
    public static Status_Unauthorized = '401';
    public static Status_NotFound = '404';

    public static Status_tMedicine_NotAllowInActive = 'NotAllowInActive';
    public static Status_tMedicine_Dup_mediCode = 'Dup_MediCode';
    public static Status_tMedicine_Dup_mediBarCode = 'Dup_MediBarCode';

    public static Status_tMediConv_NotAllowEdit = 'NotAllowEdit';
    public static Status_tMediCost_NotAllowEdit = 'NotAllowEdit';

    public static Status_tPatient_Dup_PatientID = 'Dup_PatientID';
    public static Status_tPatient_NotAllowInActive = 'NotAllowInActive';

    public static Status_General_NotAllowInActive = 'General_NotAllowInActive';
    public static Status_General_Dup_KeyCode = 'General_Dup_KeyCode';
    public static Status_General_Dup_KeyCode_HKID = 'General_Dup_KeyCode_HKID';
    public static Status_General_NotAllowAdd = 'General_NotAllowAdd';
    public static Status_General_NotAllowEdit = 'General_NotAllowEdit';
    public static Status_General_NotAllowDel = 'General_NotAllowDel';

    public static Status_General_InUse = 'General_InUse';


    public static Status_Package_Used = 'Package_Used';
    public static Status_Package_OverUsed = 'Package_OverUsed';
    public static Status_Package_Required_Over = 'Status_Package_Required_Over';

    public static Status_BillPay_PaymentFinished = "BillPay_PaymentFinished";
    public static Status_BillPay_PaymentChange = "BillPay_PaymentChange";

    public static Status_BillPay_Prescription_Price_NotMatch = "Status_BillPay_Prescription_Price_NotMatch";
    public static Status_BillPay_PackageRemainerNotEnough = "Status_BillPay_PackageRemainerNotEnough";

}


